/* ============================================================
   FAQ — editorial reading-room Q&A.
   - Category chips filter the question ledger.
   - Plate layout: clicking a question features it in the right-hand
     plate (and, on mobile where the plate is hidden, opens it as a
     single-open accordion).
   - List layout: each question is an independent accordion.
   - "Helpful?" is a local acknowledgement only (records nothing).
   Progressive enhancement: every answer is already in the DOM, so the
   section is fully readable without JS.
   ============================================================ */
(function () {
  function init(section) {
    if (section.__faqInit) return;
    section.__faqInit = true;

    var layout = section.getAttribute('data-faq-layout') || 'plate';
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-faq-item]'));
    var chips = Array.prototype.slice.call(section.querySelectorAll('[data-faq-chip]'));
    var plate = section.querySelector('[data-faq-plate]');
    var swap = plate ? plate.querySelector('[data-faq-swap]') : null;

    if (!items.length) return;

    // Plate references + meta config (plate layout only)
    var pFolio, pCat, pQ, pBody, pMeta, qword, filed, total, originalVoteHTML = null;
    if (plate) {
      pFolio = plate.querySelector('[data-faq-plate-folio]');
      pCat = plate.querySelector('[data-faq-plate-cat]');
      pQ = plate.querySelector('[data-faq-plate-q]');
      pBody = plate.querySelector('[data-faq-plate-body]');
      pMeta = plate.querySelector('[data-faq-plate-meta]');
      qword = plate.getAttribute('data-faq-qword') || 'Question';
      filed = plate.getAttribute('data-faq-filed') || 'Filed under';
      total = plate.getAttribute('data-faq-total') || String(items.length);
      var voteBox = plate.querySelector('[data-faq-vote]');
      if (voteBox) originalVoteHTML = voteBox.innerHTML;
    }

    // Initial active index = the server-rendered .is-active item (else 0)
    var activeIndex = 0;
    for (var n = 0; n < items.length; n++) {
      if (items[n].classList.contains('is-active')) { activeIndex = n; break; }
    }
    var category = '';

    function resetVote() {
      if (!plate || originalVoteHTML == null) return;
      var box = plate.querySelector('[data-faq-vote]');
      if (box) box.innerHTML = originalVoteHTML;
    }

    function fillPlate(i) {
      if (!plate) return;
      var it = items[i];
      var folio = it.getAttribute('data-faq-folio') || '';
      var cat = it.getAttribute('data-faq-cat') || '';
      var qEl = it.querySelector('.faq__qtext');
      var bodyEl = it.querySelector('[data-faq-qbody]');
      if (pFolio) pFolio.textContent = folio;
      if (pCat) pCat.textContent = cat;
      if (pQ) pQ.textContent = qEl ? qEl.textContent : '';
      if (pBody) pBody.innerHTML = bodyEl ? bodyEl.innerHTML : '';
      if (pMeta) pMeta.textContent = qword + ' ' + folio + ' / ' + total + ' · ' + filed + ' ' + cat;
      resetVote();
      // Replay the swap animation (transform-only; restart by forcing reflow).
      if (swap) { swap.style.animation = 'none'; void swap.offsetWidth; swap.style.animation = ''; }
    }

    // Plate layout: select a question (single-open).
    function setActive(i) {
      activeIndex = i;
      items.forEach(function (it, j) {
        var on = j === i;
        it.classList.toggle('is-active', on);
        var body = it.querySelector('[data-faq-qbody]');
        if (body) body.hidden = !on;
        var btn = it.querySelector('[data-faq-q]');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      fillPlate(i);
    }

    // List layout: independent accordion toggle.
    function toggleItem(item, btn) {
      var body = item.querySelector('[data-faq-qbody]');
      if (!body) return;
      var open = !body.hidden;
      body.hidden = open;
      item.classList.toggle('is-active', !open);
      if (btn) btn.setAttribute('aria-expanded', !open ? 'true' : 'false');
    }

    function setCategory(cat) {
      category = cat;
      items.forEach(function (it) {
        var show = cat === '' || it.getAttribute('data-faq-cat') === cat;
        it.hidden = !show;
      });
      chips.forEach(function (c) {
        var on = c.getAttribute('data-faq-cat') === cat;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // Keep the plate populated: if the active item is filtered out, feature the first visible one.
      if (plate) {
        var act = items[activeIndex];
        if (!act || act.hidden) {
          for (var k = 0; k < items.length; k++) {
            if (!items[k].hidden) { setActive(k); break; }
          }
        }
      }
    }

    function doVote(btn) {
      var box = btn.closest('[data-faq-vote]');
      if (!box) return;
      var thanks = box.getAttribute('data-faq-thanks') || 'Thanks.';
      while (box.firstChild) box.removeChild(box.firstChild);
      var done = document.createElement('span');
      done.className = 'faq__vote-done';
      done.textContent = thanks;
      box.appendChild(done);
    }

    section.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-faq-chip]');
      if (chip && section.contains(chip)) { setCategory(chip.getAttribute('data-faq-cat')); return; }

      var voteBtn = e.target.closest('[data-faq-vote-yes],[data-faq-vote-no]');
      if (voteBtn && section.contains(voteBtn)) { doVote(voteBtn); return; }

      var q = e.target.closest('[data-faq-q]');
      if (q && section.contains(q)) {
        var item = q.closest('[data-faq-item]');
        var i = items.indexOf(item);
        if (i < 0) return;
        if (layout === 'list') toggleItem(item, q);
        else setActive(i);
      }
    });

    // Sync chips/visibility; the server already rendered the correct active item.
    setCategory('');
  }

  function boot() { document.querySelectorAll('[data-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
